import styled from 'styled-components';
import { black, boxShadow1, exactWhite, lightGray } from 'utils/style/colors';

export const BoxContainer = styled.div`
  //margin: 1rem 0;
  height: calc(100vh - 48px);

  width: 100%;
  background-color: ${exactWhite};
  border-radius: 1.5rem;
  box-shadow: ${boxShadow1};
  @media only screen and (max-width: 1100px) {
    height: calc(100vh);
    border-radius: 0;
  }
`;

// header container
export const HeaderContainer = styled.div`
  color: ${black};
  padding: 1rem 0.5rem;

  & > div {
    height: 3rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  @media only screen and (max-width: 600px) {
    & > div {
      height: 8rem;
    }
  }
`;

export const Truncate = styled('div')`
  display: flex;
  overflow: auto;
  white-space: nowrap;
  text-overflow: ellipsis;
  & > a {
    color: ${black};
  }
`;

export const ListColumnContainer = styled.div`
  position: relative;
  height: calc(100% - 1.3rem);
  border: 0.05rem solid ${lightGray};
  border-radius: 1rem;
  margin: 0 0.5rem;
  overflow: hidden;
  display: flex;
  flex-direction: column;
`;

export const ListNavbar = styled.nav``;
export const FilterContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  gap: 0.5rem;
  @media only screen and (max-width: 600px) {
    width: 100%;
  }
`;

export const DropdownContainer = styled.div`
  background-color: var(--exact-white);
  flex: 1;
  padding: 0.8rem 0.4rem;
  display: flex;
  flex-direction: column;
`;
export const DropdownItem = styled.div`
  padding: 0 0.4rem;
`;
export const LocalIconMenuItem = styled.span`
  display: flex !important;
  gap: 10px !important;
  align-items: center !important;
`;
